import { call, put } from 'redux-saga/effects';
import GetListHistoryActions from '../redux/GetListHistoryRedux';
import { api } from './api';


export function* getlisthistorysagas(action: any): Generator<any, void, any> {
  const { type_id, children_id, page } = action;
  const response = yield call(api.getListHistory, type_id, children_id, page);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetListHistoryActions.getListHistorySuccess(response.data));
  } else {
    yield put(GetListHistoryActions.getListHistoryFailure());
  }
}